// Course utilities moved from courseSlice

const secondsInAnHour = 60 * 60;

const periodMultipliers = {
  0: 1,
  1: 24,
  2: 30 * 24
};

export const courseAccessTimePeriod = [
  { value: 'hour', text: 'Hours' },
  { value: 'day', text: 'Days' },
  { value: 'month', text: 'Months' }
]

export const secondsToPeriod = seconds => {
  let selectedIndex = 0;
  let amount = 0;
  Object.keys(periodMultipliers)
    .sort((a, b) => b - a)
    .forEach(index => {
      if (
        amount < 1 &&
        seconds % (secondsInAnHour * periodMultipliers[index]) === 0
      ) {
        amount = seconds / (secondsInAnHour * periodMultipliers[index]);
        selectedIndex = parseInt(index, 10);
      }
    });
  return { type: courseAccessTimePeriod[selectedIndex].value, amount };
};
